import { createSlice } from '@reduxjs/toolkit'

interface TourState {
  enabled: boolean;
  disableInteraction: boolean;
  step: number;
}

const initialState: TourState = {
  enabled: false,
  disableInteraction: true,
  step: 0
};

const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    show(state) {
      state.enabled = true;
    },

    setStep(state, { payload: step }) {
      state.step = step;
    },

    hide(state) {
      state.enabled = false;
      state.step = 0;
    }
  }
});

export const {
  show,
  setStep,
  hide
} = tourSlice.actions;
export default tourSlice.reducer;
